import { generateTestId } from "@client-shared";

export const setDisconnectProductDialogTestId = () => {
  const component = "DisconnectProductDialog";
  return {
    content: generateTestId(component, "content"),
    title: generateTestId(component, "title"),
    body: generateTestId(component, "body"),
    cancel: generateTestId(component, "cancel"),
    confirm: generateTestId(component, "confirm"),
  };
};
